module.exports = __webpack_public_path__ + "static/media/053-Hotspot.4c3b930a.svg";